import { notification } from "antd";
import { getFileBase64 } from "../../../utils/commonFunctions";
import styles from "../styles/style.module.scss";
import Input from "../../input";
import TextArea from "../../textarea";
import { Button } from "react-bootstrap";
import moment from "moment";

import { useState } from "react";
import { functionService } from "../../../lib/functions";
import { useNavigate } from "react-router-dom";

const TrainingSessionDetails = ({
  setTrainingData,
  type,
  trainingData,
}) => {
  const [errorArray, setErrorArray] = useState([]);
  const [imageUpdate, setImageUpdated] = useState(false);

  let navigate = useNavigate();



  const handleInputChange = (e) => {


    const { name, value } = e.target;

    console.log({ name, value });
    setTrainingData({
      ...trainingData,
      [name]: value,
    });
  };


  const onFileUpload = async (event) => {
    const file = event.target.files?.[0];
    if (file) {
      const base64 = await getFileBase64(file);

      setTrainingData({
        ...trainingData,
        img: base64,
      });
      setImageUpdated(true);
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Try again later`,
      });
    }
  };


  const addtraining = async ({
    duration,
    title,
    contentLink,
    img,
    registrationLink,
    description,
    startDateTime,
    teacherName,
    recordingLink,
    meetingLink,meetingKey, platformType, instanceId
  }) => {
    const data = {
      "title": title,
      "description": description,
      "registrationLink": registrationLink,
      "meetingLink": meetingLink,
      "recordingLink": recordingLink,
      "contentLink": contentLink,
      "duration": duration,
      "durationTypeWMY": "Minutes",
      "teacherName": teacherName,meetingKey, platformType, instanceId,


      "startDateTime": moment(startDateTime).utc(),
    
      "endDateTime":moment(startDateTime).add(duration,'minutes').utc(),
      
      "imageLink": img
    };

    if (type === "EDIT") {
      try {
        let { status } = await functionService.patch(
          `rocketSeries/${trainingData.id}`,
          {
            ...data, imageLink: imageUpdate ? img : undefined
          }
        );

        if (status) {
          navigate(`/training`, { replace: true });
        }
      } catch (error) {
        console.log({ error });
      }
    } else {

      try {
        let { status } = await functionService.post(`rocketSeries/new`, {
          ...data,
        });

        if (status) {
          navigate(`/training`, { replace: true });
        }
      } catch (error) {
        console.log({ error });
      }
    }
  };



  const checkFields = () => {
    let error = [];
    Object.keys(trainingData).forEach((key) => {
      if (
        trainingData !== "meetingKey" &&
        trainingData !== "platformType" &&
        trainingData !== "instanceId" &&
        trainingData !== "trainingRecordingLink" &&
        (trainingData[key] === null || trainingData[key] === "")
      ) {
        error.push(key);
      } else if (key === "sessions") {
        let sessionsError = [];

        trainingData[key].forEach((currentSession) => {
          let currentSessionErrorArray = [];
          Object.keys(currentSession).forEach((sessionKey) => {
            if (

              currentSession[sessionKey] === null ||
              currentSession[sessionKey] === ""
            ) {

              if (sessionKey !== "recordingLink") {
                currentSessionErrorArray.push(sessionKey);
              }

            }
          });

          sessionsError.push(currentSessionErrorArray);
        });

        let allSessionErrorResolved = true;

        sessionsError.forEach((currentSessionErrorArray) => {
          if (currentSessionErrorArray.length > 0) {
            allSessionErrorResolved = false;
          }
        });

        if (allSessionErrorResolved) {

          error = error.filter((currentError) => {
            return typeof currentError === "string";
          });
        } else {

          error.push({ session: sessionsError });
        }
      }
    });

    error = error.filter((currentError => currentError !== "discordLink" && currentError !== "alternateName" && currentError !== "role"
    ))
    setErrorArray([...error]);

    if (error.length === 0) {
      addtraining(trainingData);
    }
  };






  return (
    <>
      <Input
        error={errorArray.includes("title")}
        label="Title"
        type={"text"}
        placeholder={"Enter title"}
        value={trainingData.title}
        name={"title"}
        onChangeHandler={handleInputChange}
      />
      <TextArea
        error={errorArray.includes("description")}
        label="Description"
        type="text"
        placeholder="Enter description"
        value={trainingData.description}
        name="description"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("duration")}
        label="Training Duration (In minutes)"
        type="number"
        placeholder="Enter duration"
        value={trainingData.duration}
        name="duration"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("registrationLink")}
        label="Registration link"
        type="text"
        placeholder="Enter Registration link"
        value={trainingData.registrationLink}
        name="registrationLink"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("teacherName")}
        label="Teacher Name"
        type="text"
        placeholder="Enter Teacher Name"
        value={trainingData.teacherName}
        name="teacherName"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("meetingLink")}
        label="Meeting Link"
        type="text"
        placeholder="Enter Meeting Link"
        value={trainingData.meetingLink}
        name="meetingLink"
        onChangeHandler={handleInputChange}
      />
      <Input
        error={errorArray.includes("startDateTime")}
        label="Start Date & Time"
        type="datetime-local"
        value={moment(trainingData.startDateTime).format(
          "YYYY-MM-DD HH:mm"
        )
        }
        name="startDateTime"
        onChangeHandler={handleInputChange}
      />







      <Input
        error={errorArray.includes("maximumSeats")}
        label="Maximum seats"
        disabled={type === "EDIT"}
        type="number"
        placeholder="Enter Maximum Seats"
        value={trainingData.maximumSeats}
        name="maximumSeats"
        onChangeHandler={handleInputChange}
      />
      <Input
        error={errorArray.includes("availableSeats")}
        label="Available Seats"
        disabled={type === "EDIT"}
        type="number"
        placeholder="Enter Available Seats"
        value={trainingData.availableSeats}
        name="availableSeats"
        onChangeHandler={handleInputChange}
      />




      <Input
        error={errorArray.includes("contentLink")}
        label="Content link"
        type="text"
        placeholder="Enter Content link"
        value={trainingData.contentLink}
        name="contentLink"
        onChangeHandler={handleInputChange}
      />
      <Input
        error={errorArray.includes("recordingLink")}
        label="Recording link"
        type="text"
        placeholder="Enter Recording link"
        value={trainingData.recordingLink}
        name="recordingLink"
        onChangeHandler={handleInputChange}
      />




<Input
        error={errorArray.includes("meetingKey")}
        label="Meeting Key"
        type="text"
        placeholder="Meeting Key"
        value={trainingData.meetingKey}
        name="meetingKey"
        onChangeHandler={handleInputChange}
      />

<Input
        error={errorArray.includes("platformType")}
        label="Platform Type"
        type="text"
        placeholder="Platform Type"
        value={trainingData.platformType}
        name="platformType"
        onChangeHandler={handleInputChange}
      />


<Input
        error={errorArray.includes("instanceId")}
        label="Instance Id"
        type="text"
        placeholder="Instance Id"
        value={trainingData.instanceId}
        name="instanceId"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("img")}
        label="Upload image"
        type="file"
        name="img"
        accept="image/*"
        onChangeHandler={onFileUpload}
      />
      {trainingData.img && (
        <img
          style={{
            margin: "20px 0 20px 50px",
            objectFit: "contain",
            height: "200px",
            width: "auto",
          }}
          src={trainingData.img}
        />
      )}



      <div className={styles.sessionCompletionButton}>
        <Button
          variant="primary"
          className={styles.saveProceed}
          onClick={() => checkFields()}
        >
          Save & Proceed
        </Button>
      </div>
    </>
  );
};

export default TrainingSessionDetails;
